<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0 breadcrum-heading">
            User Detail
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body class="mb-4">
        <b-card-body>
          <b-row>
            <b-col md="12">
              <data-table
                :table-columns="tableColumns"
                :table-data="usersList"
                :border="true"
                row-class-name="row-expanded"
                :loading="loading"
                :expanded="false"
                :row-actions="rowActions"
              >
                <template #header-action>
                  <base-button
                    size="md"
                    type="primary"
                    @click="toggleAddUserForm(true)"
                  >
                    <span class="fas fa-plus"></span>
                    Add User
                  </base-button>
                </template>
              </data-table>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-container>
    <add-user
      :show-add-user-modal-form="showAddUserModalForm"
      :item="itemData"
      @close="toggleAddUserForm(false)"
    ></add-user>
  </div>
</template>

<script>
import { RouteBreadCrumb } from "@/components";
import { confirmDialogService, membersService } from "@/core/services";
import AddUser from "@/views/users/component/AddUser.vue";

import { mapGetters } from "vuex";

export default {
  name: "Users",
  components: {
    RouteBreadCrumb,
    AddUser,
  },
  data() {
    return {
      tableColumns: [
        {
          prop: "full_name",
          label: "First Name",
          sortable: true,
          searchable: true,
        },

        {
          prop: "email",
          label: "Email",
          searchable: true,
        },

        {
          prop: "phone",
          label: "Phone",
          searchable: true,
        },
      ],
      rowActions: [
        {
          variant: "warning",
          icon: "fa fa-edit",
          handler: (row, _index, _column) => {
            // this.test();
            this.showAddUserModalForm = true;
            this.itemData = row;
            this.editeOption = true;
          },
        },
        {
          variant: "danger",
          icon: "fa fa-trash",
          handler: (row, _index, _column) => {
            confirmDialogService.open(
              "Are you sure you want to delete this member?",
              () => {
                membersService.drop(row.id).then((_res) => {});
              }
            );
          },
          condition: (_rowItem) => {
            return _rowItem.user_type_id != 1;
          },
        },
      ],
      tableData: [],
      loading: false,
      showAddUserModalForm: false,
      itemData: {},
    };
  },
  computed: {
    dtRef() {
      return this.$refs.dt;
    },

    ...mapGetters("member", ["usersList"]),
  },
  mounted() {
    this.getAllUsers();
  },
  methods: {
    toggleAddUserForm(val) {
      this.showAddUserModalForm = val;
      if (!val) {
        this.itemData = {};
      }
    },
    getAllUsers() {
      this.loading = true;
      membersService.users().finally(() => {
        this.loading = false;
      });
    },
    test() {
      alert("SDdsds");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .dt-detail-info {
    &__content-sec {
      &--passenger {
        .heading {
          margin-bottom: 0.8em;
          margin-top: 1em;
          font-size: 0.8rem;
          font-weight: 700;
        }
        .pass-detail {
          margin-bottom: 0.5em;
        }
      }
      &--pricing {
        .price-detail {
          margin-bottom: 0.8em;
          .col-md-3 {
            display: flex;
          }
          .badge {
            margin-right: 1em;
          }
          .time-label {
            font-weight: 500;
            width: 40%;
          }
          .time-value {
            font-weight: 500;
          }
        }
      }
      &--customer {
        .address {
          padding-bottom: 0.18em;
          .label {
            font-weight: 600;
            color: #807d7d;
            padding-right: 1em;
          }
        }
      }
    }
  }
}
</style>
